// extracted by mini-css-extract-plugin
module.exports = {"previewHeader":"style_previewHeader__1rP3i","tableStyle":"style_tableStyle__BAXa-"};